import React from 'react';
import * as svg from '@progress/kendo-svg-icons';
import { aiApi } from '../../../../redux/api/AIApi';
import { ITicket } from '../../../../types/Ticket/ITicket';
import { Card, CardBody, CardHeader, PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { SvgIcon } from '@progress/kendo-react-common';
import { TicketApi } from '../../../../redux/api/TicketApi';

const AISummary: React.FC<ITicket> = (ticket) => {


    return (
        <div className="ai-summary">
            {/* <PanelBar>
                <PanelBarItem id="ai-summary" title='AI Summary' svgIcon={svg.sparklesIcon}>                    
                </PanelBarItem>
            </PanelBar> */}
            <Card className='no-pop'>
                <CardHeader>
                    <SvgIcon icon={svg.sparklesIcon}></SvgIcon> AI Summary
                </CardHeader>
                <CardBody className='pt-4'>
                    <AISummaryText {...ticket} /></CardBody>
            </Card>

        </div>
    );
};

const AISummaryText: React.FC<ITicket> = (ticket) => {
    const { data: summary, isFetching } = aiApi.useGetTicketSummaryQuery({ ticketId: ticket.ID });
    const { data: userProfile } = TicketApi.useGetUserProfileQuery();

    if (isFetching) return <div className='ms-4 mb-4'>Summarizing Ticket Details...</div>

    return (<>
        <div dangerouslySetInnerHTML={{ __html: summary?.Content[0]?.Text.replace('```html', '').replace('```', '') }} ></div>
        <div className="alert alert-warning text-center mt-5" role="alert"><SvgIcon icon={svg.warningTriangleIcon}></SvgIcon> {userProfile?.Phrases.CallPhrase} summaries are generated by AI and may not always reflect the complete accuracy or details of the original {userProfile?.Phrases.CallPhrase} .</div>
    </>
    );

}

export default AISummary;